import { asyncLoadRouter } from '@router/helper'

const account = [
  {
    path: 'account',
    component: asyncLoadRouter('manager/Account'),
    children: [
      {
        path: '',
        name: 'manager-account-show',
        component: asyncLoadRouter('manager/account/Show'),
        redirect: () => {
          return { name: 'manager-account-edit' }
        },
        meta: {
          breadcrumb: (i18n) => [
            { text: i18n.t('account.menus.my_account'), to: { name: 'manager-account-edit' } },
          ],
        },
        children: [
          {
            path: 'edit',
            name: 'manager-account-edit',
            component: asyncLoadRouter('manager/account/Form'),
            meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.edit') }] },
            props: { action: 'update' },
          },
        ],
      },
      {
        path: 'profile',
        component: asyncLoadRouter('manager/account/Profile'),
        redirect: () => {
          return { name: 'manager-account-profile-edit' }
        },
        meta: {
          breadcrumb: (i18n) => [
            {
              text: i18n.t('account/profile.menus.my_profile'),
              to: { name: 'manager-account-profile-edit' },
            },
          ],
        },
        children: [
          {
            path: 'edit',
            name: 'manager-account-profile-edit',
            component: asyncLoadRouter('manager/account/profile/Form'),
            meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.edit') }] },
            props: { action: 'update' },
          },
        ],
      },
      {
        path: 'contact',
        component: asyncLoadRouter('manager/account/Contact'),
        redirect: () => {
          return { name: 'manager-account-contact-edit' }
        },
        meta: {
          breadcrumb: (i18n) => [
            {
              text: i18n.t('contact.menus.my_contact'),
              to: { name: 'manager-account-contact-edit' },
            },
          ],
        },
        children: [
          {
            path: 'edit',
            name: 'manager-account-contact-edit',
            component: asyncLoadRouter('manager/account/contact/Form'),
            meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.edit') }] },
            props: { action: 'update' },
          },
        ],
      },
      {
        path: 'address',
        component: asyncLoadRouter('manager/account/Address'),
        redirect: () => {
          return { name: 'manager-account-address-edit' }
        },
        meta: {
          breadcrumb: (i18n) => [
            {
              text: i18n.t('address.menus.my_address'),
              to: { name: 'manager-account-address-edit' },
            },
          ],
        },
        children: [
          {
            path: 'edit',
            name: 'manager-account-address-edit',
            component: asyncLoadRouter('manager/account/address/Form'),
            meta: { breadcrumb: (i18n) => [{ text: i18n.t('shared.actions.edit') }] },
            props: { action: 'update' },
          },
        ],
      },
    ],
  },
]

export default account
